import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import GuideMeButton from '../components/GuideMeButton';
import Intro from '../components/Intro';
import HeroContext from '../PageContext';
import AssessmentCard from '../components/SmallAssessmentCard';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    flexGrow: 1,
    padding: '40px 30px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      padding: 0,
    },
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  container: {
    [theme.breakpoints.up('1140')]: {
      // width: 1140,
      padding: 0,
    },
    display: ({ isTablet }) => isTablet && 'flex !important',
    flexWrap: ({ isTablet }) => isTablet && 'nowrap',
    // flexDirection: 'column',
    width: '100%',
    padding: '24px 5%',
    '& p': {
      textAlign: 'left',
    },
    '& button': {
      fontSize: 18,
      lineHeight: '23px',
      fontFamily: 'MadaBold',
    },
  },
  grid: {
    width: ({ isTablet }) => (isTablet ? '50%' : '100%'),
  },
}));

function VariantJ({ isMobile, isTablet }) {
  const classes = useStyles({ isTablet });
  const { featuredResources, sendMixpanelEvent, clientInfo } = useContext(
    HeroContext,
  );
  const clickHandler = (title, props) => {
    sendMixpanelEvent(title, props);
  };

  return (
    <>
      <div className={classes.root} data-test-id="hero-variant-g">
        <Grid container className={classes.container}>
          <Grid className={classes.grid}>
            <Intro isLandingPage={false} twoCardStyle />
          </Grid>
          {!_isEmpty(_get(featuredResources, [0, 0])) && (
            <Grid className={classes.grid}>
              <AssessmentCard
                data={_get(featuredResources, [0, 0])}
                clickHandler={clickHandler}
                locale={_get(clientInfo, [0, 'locale'])}
                isMobile={isMobile}
                isTablet={isTablet}
              />
            </Grid>
          )}
          <GuideMeButton noGuideMe />
        </Grid>
      </div>
      <div className={classes.root} data-test-id="hero-variant-g">
        <Grid container className={classes.container}>
          <Grid className={classes.grid}>
            <Intro isLandingPage={false} otherLanguage twoCardStyle />
          </Grid>
          {!_isEmpty(_get(featuredResources, [1, 0])) && (
            <Grid className={classes.grid}>
              <AssessmentCard
                data={_get(featuredResources, [1, 0])}
                clickHandler={clickHandler}
                locale={_get(clientInfo, [1, 'locale'])}
                otherLanguage
                isMobile={isMobile}
                isTablet={isTablet}
              />
            </Grid>
          )}
          <GuideMeButton noGuideMe otherLanguage />
        </Grid>
      </div>
    </>
  );
}

export default VariantJ;
